import classNames from "classnames"

import * as S from "./styles"

const Icon = ({ iconMarkup, iconName }) => {
  const componentClass = classNames("icon", {
    [`icon--${iconName}`]: !!iconName,
  })

  return (
    <div
      css={S.icon}
      className={componentClass}
      dangerouslySetInnerHTML={{
        __html: iconMarkup,
      }}
    />
  )
}

export default Icon
